import React from 'react'
import styled from 'styled-components'

type Props = {
  isShort?: boolean
}

export const DivideLine: React.FC<Props> = ({ isShort }) => {
  return <StyleDivideLine short={isShort} />
}
const StyleDivideLine = styled.div<{ short?: boolean }>`
  border-bottom: solid 1px var(--ion-color-gray100);
  margin: ${(props) => (!props.short ? null : '0 20px')};
`
